import React from "react";

const Breadcrumb = ({ breadcrumb }) => {
  return (
    <div className="my-4 page-header-breadcrumb d-flex align-items-center justify-content-between flex-wrap gap-2">
      <div>
        {/* Render current section title if it exists */}
        {breadcrumb?.current_section && (
          <h1 className="page-title fw-medium fs-18 mb-2">
            {breadcrumb.current_section}
          </h1>
        )}
        <div>
          <nav>
            <ol className="breadcrumb mb-0">
              {/* Check if breadcrumb sections exist and are not empty */}
              {breadcrumb?.sections && breadcrumb.sections.length > 0
                ? breadcrumb.sections.map((link, index) => (
                    <li
                      key={index}
                      className={`breadcrumb-item ${
                        index + 1 === breadcrumb.sections.length ? "active" : ""
                      }`}
                      aria-current={
                        index + 1 === breadcrumb.sections.length
                          ? "page"
                          : undefined
                      }
                    >
                      {/* Conditionally render link or plain text */}
                      {index + 1 === breadcrumb.sections.length ? (
                        link.name
                      ) : (
                        <a
                          href={
                            link.route_name
                              ? route(link.route_name, link.params)
                              : "#"
                          }
                        >
                          {link.name}
                        </a>
                      )}
                    </li>
                  ))
                : null}
            </ol>
          </nav>
        </div>
      </div>
    </div>
  );
};

const route = (routeName, params) => {
  return `/${routeName}/${params.join("/")}`;
};

export default Breadcrumb;
